var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { space } from 'styled-system';
import { styled } from "../utils";
var StyledMain = styled.main(function (_a) {
    var backgroundColor = _a.backgroundColor, colors = _a.theme.colors;
    return "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  background-color: ".concat(backgroundColor || colors.secondary, ";  \n");
}, space);
var Main = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(StyledMain, __assign({}, props), children);
};
export default Main;
//# sourceMappingURL=Main.js.map